export const core = {
    state: {
        settings:'',
        lang: 'en',
        featuresStatus: {
            magnify_cursor: false,
            brightness: 0,
            disable_animation: false,
            legible_font: false,
            font_size: 0,
            reading_guide: false,
            highlight_links: false,
            letter_spacing: 0,
            text_magnify: false,
            text_to_speech: false,
            highlight_titles: false,
            tool_tip: false,
            speechToText: false,
            textToSpeechLang: null,
            speechToTextLang: {
                source: 'en',
                target: 'en'
            },
            sign_language: false
        }
    },
    mutations: {
        SET_SETTINGS (state,settings) {
            state.settings = settings
        },
        SET_LANG (state,lang) {
            state.lang = lang
        },
        SET_FEATURE_STATUS (state,status){
            state.featuresStatus = status
        }
    },
    actions: {
        setSettings({commit},settings) {
            commit('SET_SETTINGS', settings)
        },
        setLang({commit},lang) {
            commit('SET_LANG', lang)
        },
        setFeatureStatues ({commit},status) {
            commit('SET_FEATURE_STATUS', status)
        },
    }
}
